// extracted by mini-css-extract-plugin
export default {"container_root":"card_container_root__plebf","report_root":"card_report_root__rI-T0","item":"card_item__4fWt2","big":"card_big__qXRHu","textInner":"card_textInner__tDJfc"};